import type { MarketingCampaignStatus, MarketingRecipientStatus } from '@jr2os/shared'

/** Los colores de cada estado, en un solo sitio: listado y detalle los comparten. */
export const PILL_CAMPAIGN: Record<MarketingCampaignStatus, string> = {
  BORRADOR: 'bg-slate-500/15 text-slate-700 dark:text-slate-300 border-slate-500/40',
  PROGRAMADA: 'bg-sky-500/15 text-sky-700 dark:text-sky-300 border-sky-500/40',
  ENVIANDO: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300 border-emerald-500/40',
  PAUSADA: 'bg-amber-500/15 text-amber-700 dark:text-amber-300 border-amber-500/40',
  ENVIADA: 'bg-jr2-500/15 text-jr2-700 dark:text-jr2-300 border-jr2-500/40',
  CANCELADA: 'bg-rose-500/15 text-rose-700 dark:text-rose-300 border-rose-500/40',
}

export const PILL_RECIPIENT: Record<MarketingRecipientStatus, string> = {
  PENDIENTE: 'bg-slate-500/15 text-slate-700 dark:text-slate-300 border-slate-500/40',
  ENVIADO: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300 border-emerald-500/40',
  FALLIDO: 'bg-rose-500/15 text-rose-700 dark:text-rose-300 border-rose-500/40',
  SUPRIMIDO: 'bg-amber-500/15 text-amber-700 dark:text-amber-300 border-amber-500/40',
  CANCELADO: 'bg-slate-500/10 t-faint border-slate-500/30',
}
